@if (routerLink) {
    <a class="dashboard-stats-card dashboard-stats-card--link" [routerLink]="routerLink" [queryParams]="queryParams">
        <div class="dashboard-stats-card-header">
            <span class="stats-card-heading">{{ title }}</span>
        </div>
        <div class="dashboard-stats-card-detail">
            <span class="stats-number">{{ count }}</span>
            <span class="stats-sub-title">{{ subtitle }}</span>
        </div>
    </a>
} @else {
    <div class="dashboard-stats-card">
        <div class="dashboard-stats-card-header">
            <span class="stats-card-heading">{{ title }}</span>
        </div>
        <div class="dashboard-stats-card-detail">
            <span class="stats-number">{{ count }}</span>
            <span class="stats-sub-title">{{ subtitle }}</span>
        </div>
    </div>
}
